module.exports = __webpack_public_path__ + "c51d93e04a0fea2c823c31d14e13cb6f.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/lifeQuestionQ2.mp4
// module id = 411
// module chunks = 0